<template>
  <div>
    <form role="form" @submit.stop.prevent="emitForm()">
      <div class="vx-col sm:w-3/3 w-full mb-2 card">
        <vs-card>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label for="" class="vs-select--label">Tipo</label>
              <v-select
                :options="tipos"
                name="Tipo"
                id="Tipo"
                v-model="form.tipo"
                v-validate="{ required: true }"
                label="label"
                :state="validateState('Tipo')"
                :class="validateClass('Tipo')"
                @input="selecionaGrupoAgregado()"
                :disabled="editarComplemento"
              ></v-select>
            </div>

            <div
              v-if="this.form.tipo === 'agregado'"
              class="vx-col sm:w-1/2 w-full mb-2"
            >
              <label for="" class="vs-select--label">Grupo do Agregado</label>
              <v-select
                :options="gruposAgregados"
                name="Grupo do Agregado"
                id="Grupo do Agregado"
                v-model="idGrupo"
                v-validate="{ required: true }"
                label="label"
                :state="validateState('Grupo do Agregado')"
                :class="validateClass('Grupo do Agregado')"
                @input="selecionaGrupoAgregado(), buscarProdutos()"
                :disabled="editarComplemento"
              >
                <template #option="{ label, descricaoProdutos }">
                  <div style="padding-bottom: 5px">
                    <b style="margin: 0; display: block">{{ label }}</b>
                    <em v-if="descricaoProdutos" style="margin: 5px">{{
                      descricaoProdutos
                    }}</em>
                  </div>
                </template>
              </v-select>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <vs-input
                class="w-full"
                :label="`Descrição do ${
                  tipoComplemento || dadosComplemento.tipo
                }`"
                name="Descrição"
                v-model="form.descricao"
                v-validate="{ min: 3, required: true }"
                :state="validateState('Descrição')"
                :danger="validateClass('Descrição')"
              />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                :label="`Placa do ${tipoComplemento || dadosComplemento.tipo}`"
                v-mask="'AAA-#XX#'"
                name="Placa"
                v-model="form.placa"
                v-validate="{ min: 8 }"
                :state="validateState('Placa')"
                :danger="validateClass('Placa')"
              />
            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                :label="`Chassi do ${tipoComplemento || dadosComplemento.tipo}`"
                name="Chassi"
                v-model="form.chassi"
                v-validate="{ min: 17, max: 17 }"
                :state="validateState('Chassi')"
                :danger="validateClass('Chassi')"
              />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                :label="`Marca do ${tipoComplemento || dadosComplemento.tipo}`"
                name="Marca"
                v-model="form.marca"
                v-validate="{ min: 4, required: true }"
                :state="validateState('Marca')"
                :danger="validateClass('Marca')"
              />
            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                :label="`Modelo do ${tipoComplemento || dadosComplemento.tipo}`"
                name="Modelo"
                v-model="form.modelo"
                v-validate="{ min: 4 }"
                :state="validateState('Modelo')"
                :danger="validateClass('Modelo')"
              />
            </div>
          </div>

          <div class="vx-row">
            <div
              :class="`vx-col ${
                (exibirFormCompleto || editarComplemento) &&
                form.tipo !== 'agregado'
                  ? 'sm:w-1/2'
                  : 'sm:w-1/1'
              } w-full mb-2`"
            >
              <label for="Valor Cobertura" class="vs-input--label"
                >Valor Cobertura</label
              >
              <money
                class="w-full vs-inputx vs-input--input normal"
                name="Valor Cobertura"
                id="Valor Cobertura"
                v-model="form.valorCobertura"
                v-validate="{ required: true, min_value: 0.01 }"
                :state="validateState('Valor Cobertura')"
                :danger="validateClass('Valor Cobertura')"
                v-bind="money"
                :disabled="usarValorNf"
                @blur.native="verificaValor()"
              ></money>
            </div>

            <!-- <div
              v-if="form.tipo !== 'agregado'"
              class="vx-col sm:w-1/2 w-full mb-2"
            >
              <label  for="" class="vs-select--label">{{
                `Status do ${dadosComplemento.tipo}`
              }}</label>
              <v-select
                :options="Status"
                name="Status"
                id="Status"
                v-model="statusComplementoSelecionado"
                v-validate="{ required: true }"
                label="label"
                :state="validateState('Status')"
                :class="validateClass('Status')"
                @input="selecionaStatusComplemento()"
              ></v-select>
            </div> -->

            <div
              v-if="exibirFormCompleto"
              :class="`vx-col ${
                exibirFormCompleto ? 'sm:w-1/2' : 'sm:w-1/1'
              } w-full mt-6`"
              style="display: flex; gap: 15px"
            >
              <vs-switch
                color="success"
                style="width: 60px"
                v-model="usarValorNf"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
              <span>Substituir pelo valor da NF</span>
            </div>
          </div>

          <div
            v-if="editarComplemento && dadosComplemento.tipo == 'agregado'"
            class="vx-row"
          >
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label for="" class="vs-input--label"
                >Valor mínimo de participação</label
              >
              <money
                class="w-full vs-inputx vs-input--input normal"
                name="Valor mínimo de participação"
                id="Valor mínimo de participação"
                v-model="form.valorMinimoParticipacao"
                v-validate="{ required: true, min_value: 0.01 }"
                :state="validateState('Valor mínimo de participação')"
                :danger="validateClass('Valor mínimo de participação')"
                v-bind="money"
              ></money>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                :label="`Percentual de participação`"
                name="Percentual de participação"
                v-model="form.porcentagemParticipacao"
                :state="validateState('Percentual de participação')"
                :danger="validateClass('Percentual de participação')"
              />
            </div>
          </div>

          <!-- Se substituir valor de cobertura pelo valor da NF -->
          <div class="vx-row" v-if="usarValorNf">
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                class="w-full"
                label="Número da nota fiscal"
                name="Número da nota fiscal"
                v-model="form.numeroNF"
                v-validate="{ min: 4 }"
                :state="validateState('Número da nota fiscal')"
                :danger="validateClass('Número da nota fiscal')"
              />
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label for="" class="vs-select--label">Valor da NF</label>
              <money
                class="w-full vs-inputx vs-input--input normal"
                name="Valor da NF"
                id="Valor da NF"
                v-model="form.valorNF"
                v-validate="{ required: true, min_value: 0.01 }"
                :state="validateState('Valor da NF')"
                :danger="validateClass('Valor da NF')"
                v-bind="money"
              ></money>
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label for class="vs-input--label">Vencimento da NF</label>
              <datepicker
                class="inputData"
                :format="'dd/MM/yyyy'"
                label="DD/MM/YYYY"
                v-model="form.dataNF"
                name="Data de Vencimento da Nota Fiscal"
                id="Data de Vencimento da Nota Fiscal"
                :state="validateState('Data de Vencimento da Nota Fiscal')"
                :danger="validateClass('Data de Vencimento da Nota Fiscal')"
              ></datepicker>
            </div>
          </div>

          <div
            v-if="editarComplemento && dadosComplemento.tipo == 'agregado'"
            class="vx-row"
          >
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label for="" class="vs-select--label">{{
                `Status do ${dadosComplemento.tipo}`
              }}</label>
              <v-select
                :options="Status"
                name="Status"
                id="Status"
                v-model="statusComplementoSelecionado"
                v-validate="{ required: true }"
                label="label"
                :state="validateState('Status')"
                :class="validateClass('Status')"
                @input="selecionaStatusComplemento()"
              ></v-select>
            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label for="" class="vs-select--label"
                >Forma de Pagamento Mensal</label
              >
              <v-select
                :options="formasPagamentos"
                name="Forma de Pagamento Mensal"
                id="Forma de Pagamento Mensal"
                v-model="formaPagamentoSelecionada"
                v-validate="{ required: true }"
                label="label"
                :state="validateState('Forma de Pagamento Mensal')"
                :class="validateClass('Forma de Pagamento Mensal')"
                @input="selecionaFormaPagamento()"
              >
              </v-select>
            </div>
          </div>

          <div
            v-if="editarComplemento && dadosComplemento.tipo == 'agregado'"
            class="vx-row"
          >
            <div class="vx-col w-full mb-2">
              <vs-input
                class="w-full"
                label="Dia de Vencimento"
                v-model="form.diaVencimento"
                name="Dia de Vencimento"
                v-validate="{ required: true }"
                :state="validateState('Dia de Vencimento')"
                :danger="validateClass('Dia de Vencimento')"
              />
            </div>
          </div>

          <div
            v-if="editarComplemento && dadosComplemento.tipo == 'agregado'"
            class="vx-row"
          >
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>Participa do Rateio?</span>
              <vs-switch
                color="success"
                v-model="form.participaRateio"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>Gera Cobrança?</span>
              <vs-switch
                color="success"
                v-model="form.geraCobranca"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>Boleto Físico?</span>
              <vs-switch
                color="success"
                v-model="form.boletoFisico"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <vs-textarea label="Observações" v-model="form.observacao" />
            </div>
          </div>
        </vs-card>
        <vs-alert
          v-if="$validator.errors.all().length > 0"
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
        >
          <ul>
            <li
              class="mb-2"
              v-for="error in $validator.errors.all()"
              :key="error.id"
            >
              {{ error }}
            </li>
          </ul>
        </vs-alert>
      </div>

      <div>
        <div v-if="this.form.tipo === 'agregado'" class="vx-row">
          <div
            class="vx-col sm:w-1/2 w-full mb-2"
            v-if="dadosComplemento.produtosAgregado"
          >
            <h5 class="mt-3 mb-6 text-center">Produtos Atuais</h5>
            <hr />
            <vs-list>
              <vs-list-header
                title="Obrigatórios"
                color="green"
              ></vs-list-header>
              <vs-list-item
                v-for="item in filtraProdutosAtuais(true)"
                :key="item.idProduto"
                :title="item.nomeProduto"
                :subtitle="`${
                  item.descontoConcedido != 0
                    ? `de ${formataMoeda(item.valor)}, por `
                    : ''
                }${formataMoeda(item.valorFinal)} ${
                  item.ismensal == true ? '/mês' : ''
                }`"
              >
                <small v-if="item.descontoConcedido"
                  >Desconto: {{ item.descontoConcedido }}%</small
                >
              </vs-list-item>
              <vs-list-header
                v-if="filtraProdutosAtuais(false).length > 0"
                title="Opcionais"
                color="blue"
              ></vs-list-header>
              <vs-list-item
                v-for="item in filtraProdutosAtuais(false)"
                :key="item.idProduto"
                :title="item.nomeProduto"
                :subtitle="`${
                  item.descontoConcedido != 0
                    ? `de ${formataMoeda(item.valor)}, por `
                    : ''
                }${formataMoeda(item.valorFinal)} ${
                  item.ismensal == true ? '/mês' : ''
                }`"
              >
                <small v-if="item.descontoConcedido"
                  >Desconto: {{ item.descontoConcedido }}%</small
                >
              </vs-list-item>
            </vs-list>
            <h6 class="mt-5">
              Total Mensal: {{ somaValorTotal(true) | currency }}
            </h6>
            <h6 class="mt-5">
              Total à vista: {{ somaValorTotal(false) | currency }}
            </h6>
          </div>
          <div
            v-if="nenhumProdutoEncontrado === false"
            class="vx-col sm:w-1/2 w-full mb-2"
          >
            <h5 class="mt-3 mb-6 text-center">Produtos a serem atualizados</h5>
            <hr />
            <table class="table-bordered">
              <tr>
                <th class="w-1/6"></th>
                <th class="w-2/6">Produto</th>
                <th class="w-1/6">Valor</th>
                <th class="w-1/6">Desconto(%)</th>
                <th class="w-1/6">Valor Final</th>
                <td></td>
              </tr>
              <tr
                v-for="(item, index) in form.produtosObrigatorios"
                :key="'Obri' + index"
              >
                <td>
                  <vs-checkbox
                    v-model="form.dadosProdutosSelecionados"
                    :vs-value="item"
                    :disabled="validaSelecionado(item)"
                    @input="selecionaProduto(item)"
                  >
                  </vs-checkbox>
                </td>
                <td>{{ item.nomeProduto }}</td>
                <td>{{ item.valor | currency }}</td>
                <td>{{ item.descontoConcedido | currency }} %</td>
                <td>{{ item.valorFinal | currency }}</td>
                <td>
                  <vs-button
                    v-if="item.porcentagemDescontoMaxima"
                    radius
                    v-tooltip="'Editar Valor Final'"
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    class="d-inline"
                    @click.native.prevent="abrirModalDesconto(item)"
                    >%</vs-button
                  >
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <hr class="my-3" />
                </td>
              </tr>
              <tr
                v-for="(item, index) in form.produtosNaoObrigatorios"
                :key="'NObri' + index"
              >
                <td>
                  <vs-checkbox
                    @input="selecionaProduto(item)"
                    v-model="form.dadosProdutosSelecionados"
                    :vs-value="item"
                  >
                  </vs-checkbox>
                </td>
                <td>{{ item.nomeProduto }}</td>
                <td>{{ item.valor | currency }}</td>
                <td>{{ item.descontoConcedido | currency }} %</td>

                <td>
                  {{ item.valorFinal | currency }}
                </td>
                <td>
                  <vs-button
                    v-if="item.porcentagemDescontoMaxima"
                    radius
                    v-tooltip="'Editar Valor Final'"
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    class="d-inline"
                    @click.native.prevent="abrirModalDesconto(item)"
                    >%</vs-button
                  >
                </td>
              </tr>
            </table>

            <h6 class="mt-5">
              Total Mensal: {{ somaValorTotalAtualizados(true) | currency }}
            </h6>
            <h6 class="mt-5">
              Total à vista: {{ somaValorTotalAtualizados(false) | currency }}
            </h6>
          </div>
          <div
            v-else-if="nenhumProdutoEncontrado == true"
            class="vx-col sm:w-1/2 w-full mb-2"
          >
            <vs-alert
              title="Atenção"
              active="true"
              color="danger"
              style="max-height: 220px !important"
            >
              Nenhum produto encontrado para esse veículo, revise os dados do
              veículo
            </vs-alert>
          </div>
        </div>
        <!-- <div>
            <Modal
              class="inner-popup"
              :title="'Alterar Valor do Produto'"
              :active.sync="modalValor"
              @close="modalValor = false"
            >
              <div class="vx-row" v-if="itemValor">
                <div class="vx-col sm:w-1/1 w-full mb-2">
                  <label for="" class="vs-input--label">Valor</label>
                  <money
                    class="w-full vs-inputx vs-input--input normal"
                    name="Valor"
                    id="Valor"
                    v-model="itemValor.valorFinal"
                    v-validate="{ required: true, min_value: 0.0 }"
                    :state="validateState('Valor')"
                    :danger="validateClass('Valor')"
                    v-bind="money"
                  ></money>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full text-right">
                  <vs-button
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="d-inline"
                    @click="salvaItemValor()"
                    >Salvar</vs-button
                  >
                </div>
              </div>
            </Modal>
          </div> -->
      </div>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <BotaoSubmit
            variant="success"
            :edit="true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <div>
      <Modal
        class="holamundo"
        :title="titleSideBar"
        :active.sync="modalDesconto"
      >
        <formDesconto
          :key="contFormDesconto"
          :dados="item"
          :contador="contFormDesconto"
          :modal="modalDesconto"
          @salvarDesconto="salvaItemValor"
        >
        </formDesconto>
      </Modal>
    </div>
  </div>
</template>

<script>
import locale from '../../locale';
import Datepicker from 'vuejs-datepicker';
import { Money } from 'v-money';
import vSelect from 'vue-select';
import BotaoSubmit from '../../components/BotaoSubmit';
import service from './../../services';
import formDesconto from '../forms/formDesconto.vue';
import Modal from '../../components/Modal.vue';

export default {
  props: [
    'dadosComplemento',
    'resetFormComplemento',
    'exibirFormCompleto',
    'grupos',
    'tipoComplemento',
    'idGrupoVeiculo',
    'idEmpresa',
    'buscarProdutoAgregado',
    'dadosCliente',
    'editarComplemento',
    'formasPagamentos',
    'dadosGerais',
    'addComplementoEdicao',
  ],
  watch: {
    tipoComplemento(value) {
      this.form.tipo = value;
    },
    dadosComplemento() {
      this.preencheForm();
    },
    usarValorNf(value) {
      if (value) this.form.valorCobertura = 0;
    },
    resetFormComplemento(value) {
      if (value) this.resetForm();
    },
    grupos(value) {
      if (!value) return;
      this.gruposAgregados = value;
    },
    'form.tipo': function (value) {
      value === 'agregado' && this.buscaDadosGrupos();

      if (value === 'implemento') {
        this.idGrupo = null;
        this.form.idGrupo = null;
      }
    },
  },
  components: {
    Datepicker,
    Money,
    BotaoSubmit,
    'v-select': vSelect,
    formDesconto,
    Modal
  },
  data() {
    return {
      formaPagamentoSelecionada: null,
      Status: [
        { id: 1, label: 'ATIVO' },
        { id: 2, label: 'INATIVO' },
        { id: 3, label: 'INADIMPLENTE' },
      ],
      modalDesconto: false,
      statusComplementoSelecionado: null,
      produtos: null,
      nenhumProdutoEncontrado: null,
      tipos: ['agregado', 'implemento'],
      gruposAgregados: [],
      idGrupo: { id: null, label: 'Selecione o grupo' },
      usarValorNf: false,
      vendedoresIniciais: [],
      titleSideBar: 'Desconto',
      item: null,
      contFormDesconto: 0,
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
      aguardeCadastro: false,
      forcarAtualizacao: false,

      tiposImplementos: [],
      marcas: [],
      modelos: [],
      modelosAux: [],

      estadoPneus: ['Ruim', 'Regular', 'Bom', 'Novo'],
      form: {
        produtosSelecionados: [],
        _preencheForm: null,
        idPropostaComplemento: null,
        idProposta: null,
        descricao: null,
        index: null,
        chassi: null,
        placa: null,
        marca: null,
        modelo: null,
        valorCobertura: 0,
        numeroNF: null,
        valorNF: null,
        dataNF: null,
        observacao: null,
        idGrupo: null,
        tipo: null,
      },
    };
  },
  methods: {
    salvaItemValor(item) {
      this.item = item;
      this.modalDesconto = false;
      this.form.atualizarProdutos = true;
    },
    abrirModalDesconto(item) {
      this.contFormDesconto = this.contFormDesconto + 1;
      if (item) {
        item.id = item.id_produto;
        item.estado = this.dadosCliente.estado;
        item.tipoProposta = this.dadosGerais.tipoProposta;
        this.item = item;
        this.modalDesconto = true;
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      this.form = {
        ...this.dadosComplemento,
      };

      if (!this.dadosComplemento) return;
      if (this.dadosComplemento.tipo === 'implemento') return;
      if (this.editarComplemento === false) this.buscarProdutos();

      const { idComplemento, Status, idStatus, idTipoPagamentoMensal } =
        this.dadosComplemento;
      if (idComplemento) {
        this.idGrupo = {
          id: this.dadosComplemento.idGrupo,
          label:
            this.dadosComplemento.nomeGrupo ||
            this.dadosComplemento.nomeGrupoAgregado,
        };

        const [_formaPamento] = this.formasPagamentos.filter(
          (item) => item.id == idTipoPagamentoMensal,
        );

        this.formaPagamentoSelecionada = {
          id: _formaPamento.id,
          label: _formaPamento.label,
        };

        this.statusComplementoSelecionado = {
          id: idStatus,
          label: Status,
        };
      }
    },
    resetForm() {
      this.form.idProposta = null;
      this.form.descricao = null;
      this.form.chassi = null;
      this.form.placa = null;
      this.form.marca = null;
      this.form.modelo = null;
      this.form.valorCobertura = 0;
      this.form.numeroNF = null;
      this.form.valorNf = null;
      this.form.dataNF = null;
      this.form.index = null;
      this.form.observacao = null;
      this.form.idGrupo = null;
      this.form.JsonFacilitadorProdutos = null;
      this.idGrupo = { id: null, label: 'Selecione o grupo' };
      this.produtos = null;

      this.produtos = null;
      this.form.produtosObrigatorios = null;
      this.form.produtosNaoObrigatorios = null;
      this.form.dadosProdutosSelecionados = null;
      this.form.produtosSelecionados = null;
      this.form.idPropostaComplemento = null;
      this.dadosComplemento.produtosAgregado = null;
      this.nenhumProdutoEncontrado = null;
      // this.form.tipo = null;
    },
    emitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const _dadosComplemento = { ...this.form };

          const acao =
            _dadosComplemento.index === null ? 'adicionar' : 'atualizar';

          const editarComplementoProposta =
            this.form.idPropostaComplemento && this.form.id;

          const submitForm =
            editarComplementoProposta ||
            this.editarComplemento ||
            this.addComplementoEdicao;

          if (!submitForm) {
            this.$emit(acao, _dadosComplemento);

            const text =
              acao == 'atualizar'
                ? `${this.tipoComplemento} Atualizado`
                : `${this.tipoComplemento} Adicionado`;

            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text,
              color: 'success',
            });

            this.resetForm();
          }

          if (
            editarComplementoProposta ||
            this.editarComplemento ||
            this.addComplementoEdicao
          ) {
            this.onSubmit();
          }
        } else {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Existem campos não preenchidos',
            color: 'danger',
          });
        }
      });
    },
    async onSubmit() {
      if (this.editarComplemento == false) {
        if (this.form.atualizarProdutos && this.form.tipo == 'agregado') {
          this.form.produtos = this.produtos;
        } else {
          this.form.atualizarProdutos = false;
        }

        const acao =
          this.addComplementoEdicao && !this.form.idPropostaComplemento
            ? 'AddComplementoEdicaoProposta'
            : 'EditarComplemento';

        if (
          acao === 'AddComplementoEdicaoProposta' &&
          this.form.tipo == 'agregado'
        ) {
          delete this.form._preencheForm;
          delete this.form.idPropostaComplemento;
          delete this.form.index;
          delete this.form.atualizarProdutos;
          delete this.form.produtosObrigatorios;
          delete this.form.produtosNaoObrigatorios;

          if (this.dadosGerais.jsonFacilitador) {
            const {
              dadosFinanceiros: { avista, mensais },
            } = JSON.parse(this.dadosGerais.jsonFacilitador);

            const [_avista] = avista;
            const [_mensais] = mensais;

            this.form.dadosProdutosSelecionados.forEach((produto) => {
              if (produto.ismensal) {
                produto.idTipoPagamentoEmpresa = _mensais
                  ? _mensais.valor.idTipoPagamentoEmpresa
                  : null;
              } else {
                produto.idTipoPagamentoEmpresa = _avista
                  ? _avista.valor.idTipoPagamentoEmpresa
                  : null;
              }
            });
          }

          this.form.idProposta = this.dadosGerais.idProposta;
        }

        if (
          acao === 'AddComplementoEdicaoProposta' &&
          this.form.tipo == 'implemento'
        ) {
          delete this.form._preencheForm;
          delete this.form.atualizarProdutos;
          delete this.form.index;

          this.form.produtosSelecionados = null;
          this.form.idProposta = this.dadosGerais.idProposta;
        }

        const { data: complemento } = await service.post(
          'Cotacao',
          acao,
          this.form,
        );

        const text =
          acao === 'EditarComplemento'
            ? `Atualizado com sucesso ${complemento.tipo}`
            : `Adicionado com sucesso ${complemento.tipo}`;

        const acaoEmit =
          acao === 'EditarComplemento' ? 'atualizar' : 'adicionar';

        this.$emit(acaoEmit, complemento);
        this.resetForm();

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text,
          color: 'success',
        });

        return;
      }
    },
    selecionaGrupoAgregado() {
      this.form.idGrupo = this.idGrupo.id;
      this.form.porcentagemParticipacao = this.idGrupo.porcentagemParticipacao;
      this.form.valorMinimoParticipacao = this.idGrupo.valorMinimoParticipacao;
      this.form.nomeGrupo = this.idGrupo.label;

      if (this.form.idGrupo !== this.dadosComplemento.idGrupo) {
        this.form.atualizarProdutos = true;
      } else if (this.form.idGrupo === undefined || this.form.idGrupo == null) {
        this.form.atualizarProdutos = true;
      } else {
        this.form.atualizarProdutos = false;
      }
    },
    buscaDadosGrupos() {
      return new Promise(async (resolve, reject) => {
        if (this.editarComplemento) {
          this.selecionaGrupoAgregado();
          reject();

          return;
        }

        this.$vs.loading();
        service.getAll('Grupo', {}, 'list/' + this.idEmpresa).then((res) => {
          const [_grupos] = res.data.filter(
            ({ idGrupo }) => idGrupo == this.idGrupoVeiculo,
          );
          this.gruposAgregados = JSON.parse(_grupos.gruposAgregados);
          this.idGrupo = this.gruposAgregados.find(
            ({ id }) => id === this.dadosComplemento.idGrupo,
          );
          this.$vs.loading.close();
        });
        resolve();
      });
    },
    formataProdutos(produtos) {
      const _produtos = produtos;

      const produtosObrigatorios = _produtos.filter(
        ({ obrigatorio }) => obrigatorio === true,
      );
      const produtosNaoObrigatorios = _produtos.filter(
        ({ obrigatorio }) => obrigatorio === false,
      );

      produtosObrigatorios.forEach((element) => {
        element.valorFinal =
          Number(element.valor) -
          (Number(element.valor) *
            Number(element.descontoConcedido ? element.descontoConcedido : 0)) /
            100;
      });

      produtosNaoObrigatorios.forEach((element) => {
        element.valorFinal =
          Number(element.valor) -
          (Number(element.valor) *
            Number(element.descontoConcedido ? element.descontoConcedido : 0)) /
            100;
      });

      const dadosProdutosSelecionados = produtosObrigatorios;

      return {
        produtosObrigatorios,
        produtosNaoObrigatorios,
        dadosProdutosSelecionados,
      };
    },
    async buscarProdutos() {
      try {
        const { tipo, idPropostaComplemento } = this.form;
        const buscarProdNovoComplemeto =
          this.addComplementoEdicao &&
          this.form.idGrupo &&
          this.form.valorCobertura;
        if (
          (tipo === 'agregado' && idPropostaComplemento) ||
          this.buscarProdutoAgregado === true ||
          buscarProdNovoComplemeto
        ) {
          this.$vs.loading();
          this.produtos = null;
          this.form.produtosObrigatorios = null;
          this.form.produtosNaoObrigatorios = null;
          this.form.dadosProdutosSelecionados = null;
          this.form.produtosSelecionados = null;

          if (buscarProdNovoComplemeto) {
            this.form.cidade = this.dadosGerais.dadosCliente.cidade;
            this.form.estado = this.dadosGerais.dadosCliente.estado;
          }

          const { data: _produtos } = await service.post(
            'Cotacao',
            'BuscaProdutosComplemento',
            this.form,
          );

          if (_produtos.length === 0) {
            this.nenhumProdutoEncontrado = true;
            this.$vs.loading.close();
            return;
          }

          const { produtosObrigatorios, produtosNaoObrigatorios } =
            this.formataProdutos(_produtos);

          this.form.produtosObrigatorios = produtosObrigatorios;
          this.form.produtosNaoObrigatorios = produtosNaoObrigatorios;

          // if(this._preencheForm === false){
          this.form.dadosProdutosSelecionados = produtosObrigatorios;
          this.form.produtosSelecionados = produtosObrigatorios.reduce(
            (ids, item) => {
              ids.push(item.id_produto);
              return ids;
            },
            [],
          );

          this.form.produtosObrigatorios = produtosObrigatorios;
          this.form.produtosNaoObrigatorios = produtosNaoObrigatorios;

          this.produtos = _produtos;
          this.nenhumProdutoEncontrado = false;
          // this._preencheForm = false;
          this.$forceUpdate();

          this.$vs.loading.close();
        }
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar produtos',
          text: e,
          color: 'danger',
        });
      }
    },
    formataMoeda(valor) {
      return `R$ ${valor.toFixed(2)} `;
    },
    validaSelecionado(item) {
      const aux = this.form.dadosProdutosSelecionados.filter(
        (x) => x.id_produto == item.id_produto,
      );

      if (item.obrigatorio && aux.length > 0) return true;
      if (item.obrigatorio && aux.length == 0) return false;
    },
    selecionaProduto(item) {
      this.form.atualizarProdutos = true;

      if (item.sobreporOutrosProdutos) {
        var prodssobreporOutrosProdutos =
          item.sobreporOutrosProdutos.split(',');

        prodssobreporOutrosProdutos.forEach((element) => {
          this.form.dadosProdutosSelecionados.forEach((elementSel, index) => {
            if (elementSel.id == element) {
              this.form.dadosProdutosSelecionados.splice(index, 1);
            }
          });
        });
      } else {
        this.produtos.forEach((element) => {
          if (element.sobreporOutrosProdutos) {
            var prodssobreporOutrosProdutos =
              element.sobreporOutrosProdutos.split(',');
            var aux = prodssobreporOutrosProdutos.find(
              (x) => x == item.id_produto,
            );
            if (aux) {
              this.form.dadosProdutosSelecionados.forEach(
                (selecionado, index) => {
                  if (selecionado.id == element.id_produto) {
                    this.form.dadosProdutosSelecionados.splice(index, 1);
                  }
                },
              );
            }
          }
        });
      }

      this.buscaProdutosSobrepoeFaltante();
      this.$forceUpdate();
    },
    buscaProdutosSobrepoeFaltante() {
      var arrFaltante = [];
      this.form.produtosObrigatorios.forEach((element) => {
        var aux = this.form.dadosProdutosSelecionados.find(
          (x) => x.id_produto == element.id_produto,
        );
        if (!aux) arrFaltante.push(element);
      });
      if (arrFaltante.length > 0) {
        var arrEncontrou = [];
        arrFaltante.forEach((elementFaltante) => {
          this.form.dadosProdutosSelecionados.forEach((element) => {
            var aux = this.produtos.find(
              (x) => x.id_produto == element.id_produto,
            );
            if (aux.sobreporOutrosProdutos) {
              var prodssobreporOutrosProdutos =
                aux.sobreporOutrosProdutos.split(',');
              var aux2 = prodssobreporOutrosProdutos.filter(
                (x) => x.id_produto == elementFaltante.id_produto,
              );
              if (aux2.length > 0) {
                arrEncontrou.push(aux2[0]);
              }
            }
          });
          if (arrEncontrou.length == 0) {
            this.form.dadosProdutosSelecionados.push(elementFaltante);
          }
        });
      }
    },
    calculaValor(item) {
      const descontoConcedido = Number(item.descontoConcedido);
      const porcentagemDescontoMaxima = Number(item.porcentagemDescontoMaxima);
      const itemValor = Number(item.valor);

      let valorFinal = 0;

      const descConcedMaiorQpercDescMax =
        descontoConcedido > porcentagemDescontoMaxima;
      if (descConcedMaiorQpercDescMax) {
        item.descontoConcedido = 0;

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Valor de Desconto excede ao valor Permitido',
          color: 'danger',
        });

        return;
      } else {
        valorFinal = itemValor - (itemValor * descontoConcedido) / 100;

        const produtosSelecionados = this.form.dadosProdutosSelecionados;
        produtosSelecionados.forEach((element) => {
          if (element.id_produto == item.id_produto) {
            element.valorFinal = valorFinal;
            element.descontoConcedido = descontoConcedido;
          }
        });
        this.form.dadosProdutosSelecionados = produtosSelecionados;

        item.descontoConcedido = descontoConcedido;
        item.valorFinal = valorFinal;

        // this.filtraObrigatorios();
        // this.filtraNaoObrigatorios();
        this.filtraProdutosAtuais(true);
        this.filtraProdutosAtuais(false);
        this.$forceUpdate();
      }
    },
    somaValorTotalAtualizados(mensal = true) {
      let total = 0;
      if (this.form.dadosProdutosSelecionados)
        total = this.form.dadosProdutosSelecionados.reduce((acc, produto) => {
          if (produto.ismensal == mensal) acc += produto.valorFinal;
          return acc;
        }, 0);

      return total;
    },
    somaValorTotal(mensal = true) {
      const total = this.dadosComplemento.produtosAgregado.reduce(
        (acc, produto) => {
          if (produto.isMensal === mensal) acc += produto.valorFinal;
          return acc;
        },
        0,
      );

      return total;
    },
    filtraProdutosAtuais(produtoEObrigatorio) {
      const produtos = this.dadosComplemento.produtosAgregado.filter(
        ({ obrigatorio }) => obrigatorio === produtoEObrigatorio,
      );

      return produtos;
    },
    verificaValor() {
      const valorDeCoberturaMudou =
        this.form.valorCobertura !== this.dadosComplemento.valorCobertura;
      if (valorDeCoberturaMudou && this.editarComplemento === false) {
        this.form.atualizarProdutos = true;
        this.buscarProdutos();
      } else {
        this.form.atualizarProdutos = false;
      }
    },
    selecionaStatusComplemento() {
      this.form.Status = this.statusComplementoSelecionado.label;
      this.form.idStatus = this.statusComplementoSelecionado.id;
    },
    async selecionaFormaPagamento() {
      this.form.idTipoPagamentoMensal = this.formaPagamentoSelecionada.id;

      if (this.form.atualizarProdutos && this.form.tipo == 'agregado') {
        this.form.produtos = this.produtos;
      } else {
        this.form.atualizarProdutos = false;
      }

      const { data: complemento } = await service.post(
        'Cotacao',
        'EditarComplemento',
        this.form,
      );

      const text = `Atualizado com sucesso ${complemento.tipo}`;
      this.$emit('atualizar', complemento);
      this.resetForm();

      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text,
        color: 'success',
      });
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
  },
};
</script>
<style scoped lang="scss">
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
